<template>
  <div class="hello">
    <div class="left-panel">
      <div style="margin-top: 24px;font-weight: 800;"><span>通过修改源码中的部分逻辑，已解决了下面的问题。具体改动请看<a href="https://github.com/tinysimple/LogicFlowGroupFixPage" target="_blank">git仓库</a></span></div>
      <div style="margin-top: 24px;"><span>出现问题的业务需求为：将两个元素成组后，保持组内元素不变；即：其他元素不能进入组内，已存在的组内元素不能出组。</span></div>
      <div style="margin-top: 24px;"><span>当节点中存在分组关系时，第一次拖动分组内的节点出组时，会限制不能拖出组区域，但松开鼠标时实际已经将节点从组中删除了。</span></div>
      <div style="margin-top: 24px;"><span>这就导致了本来在组内的元素通过拖动一下即可解除分组，存在问题。</span></div>
      <div style="margin-top: 24px;"><span>在源码文件 @logicflow/extension/es/dynamic-group/index.js中的第69行中，执行的操作是“1. 如果该节点之前已经在 group 中了，则将其从之前的 group 移除”，该逻辑存在问题。</span></div>
      <div style="margin-top: 24px;"><span>其逻辑为：先将节点从组中删除，然后再判断节点是否可以加入组，可以的话再添加进组内。</span></div>
    </div>
    <div class="center-panel">
      <div ref="container" class="lf-container" id="container"></div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

import LogicFlow from "@logicflow/core";
import "@logicflow/core/dist/index.css";
import "@logicflow/extension/lib/index.css";

import { dynamicGroup, DynamicGroup } from '@logicflow/extension';

class CustomGroup extends dynamicGroup.view {
}

class CustomGroupModel extends dynamicGroup.model {
  foldedText;

  initNodeData(data) {
    super.initNodeData(data);
    this.isRestrict = true;
    this.resizable = true;
    this.width = 480;
    this.height = 280;
    this.properties = {
      ...this.properties
    }
  }

 getNodeStyle() {
    const style = super.getNodeStyle();
    style.stroke = "#AEAFAE";
    style.strokeDasharray = "3 3";
    style.strokeWidth = 1;
    style.fill = 'transparent';
    return style;
  }

  isAllowAppendIn() {
    return false;
  }
}

const customGroup = {
  type: 'custom-group',
  view: CustomGroup,
  model: CustomGroupModel,
};


let lf = null;

onMounted(() => {
  init();
});

const config = {
  isSilentMode: false,
  stopScrollGraph: true,
  stopZoomGraph: true,
  style: {
    rect: {
      rx: 5,
      ry: 5,
      strokeWidth: 2
    },
    circle: {
      fill: "#f5f5f5",
      stroke: "#666"
    },
    ellipse: {
      fill: "#dae8fc",
      stroke: "#6c8ebf"
    },
    polygon: {
      fill: "#d5e8d4",
      stroke: "#82b366"
    },
    diamond: {
      fill: "#ffe6cc",
      stroke: "#d79b00"
    },
    text: {
      color: "#b85450",
      fontSize: 12
    }
  }
};

const data = {
  nodes: [ 
    {
      id: 'group_1',
      type: 'custom-group',
      x: 300,
      y: 220,
      text: 'custom-group-1',
      properties: {
        // isFolded: false,
        children: ["rect_4"],
      },
    },
    {
      id: 'rect_4',
      type: 'rect',
      x: 350,
      y: 240,
      text: {
        value: 'rect_3',
        x: 350,
        y: 240,
        editable: false,
        draggable: true,
      },
    }]
};

function init() {
  lf = new LogicFlow({
    ...config,
    container: document.querySelector("#container"),
    width: 1080,
    height: 800,
    grid: {
      size: 10
    },
    plugins: [DynamicGroup]
  });
  lf.register(customGroup);
  lf.render(data);
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  display: flex;
  height: 840px;
  width: 100%;
  overflow: hidden;
}
.left-panel,
.right-panel {
  flex-basis: 200px;
  flex-shrink: 0;
  background: antiquewhite;
}
.center-panel {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #efefef;
  overflow: auto;
  font-size: 0;
}
.lf-container {
  overflow: auto;
  max-width: 100%;
  max-height: 100%;
}
</style>
